import { Component, ViewChild } from '@angular/core';
import { InsuranceReportRequest } from '../../models/insurance-report-request';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { InsuranceReportType } from 'src/app/enum/insurance-report-type';
import { TotalInsuranceReport } from '../../models/total-insurance-report';
import { PrintService } from 'src/app/services/print.service';
import { DataService } from 'src/app/services/data.service';
import { NewCalendarService } from 'src/app/services/new-calender-service';

@Component({
  selector: 'app-insurance-report',
  templateUrl: './insurance-report.component.html',
  styleUrl: './insurance-report.component.css',
})
export class InsuranceReportComponent {
  public backendJson: InsuranceReportRequest;
  public monthName: string = '';
  public loading: boolean = true;
  public insuranceList: any[] = [];
  public totalReport?: TotalInsuranceReport;

  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;

  constructor(
    private apiService: UserApiService,
    private logger: LoggerService,
    private dataService: DataService,
    public calendarService: NewCalendarService,
    private printService: PrintService
  ) {
    this.backendJson = new InsuranceReportRequest();
    this.GetInsurance();
  }

  public TypeDate(elementId: string): string {
    const expiteValue = (<HTMLInputElement>(
      document.getElementById(`${elementId}`)
    )).value;

    const yearDatePattern: RegExp = /^(?<year>\d{4})$/;

    const testyearDatePattern: boolean = yearDatePattern.test(expiteValue);
    if (testyearDatePattern) {
      return `${expiteValue}/`;
    }

    const monthDatePattern: RegExp = /^(?<year>\d{4})(\/{1})(?<month>\d{2})$/;

    const testmonthDatePattern: boolean = monthDatePattern.test(expiteValue);
    if (testmonthDatePattern) {
      const groups = expiteValue.match(monthDatePattern)?.groups;
      const year: number = Number(groups?.['year']);
      const month: number = Number(groups?.['month']);

      let monthString = month.toString();
      if (month < 10) {
        monthString = monthString.padStart(2, '0');
      } else if (month > 12) {
        monthString = '12';
      }

      return `${year}/${monthString}/`;
    }

    const fullDatePattern: RegExp =
      /^(?<year>\d{4})(\/{1})(?<month>\d{1,2})(\/{1})(?<day>\d{1,})/;
    const testfullDatePattern: boolean = fullDatePattern.test(expiteValue);
    if (testfullDatePattern) {
      const groups = expiteValue.match(fullDatePattern)?.groups;
      const year: number = Number(groups?.['year']);
      const month: number = Number(groups?.['month']);
      const day: number = Number(groups?.['day']);

      let monthString = month.toString();
      if (month < 10) {
        monthString = monthString.padStart(2, '0');
      } else if (month > 12) {
        monthString = '12';
      }

      let dayString = day.toString();
      if (day < 10) {
        dayString = dayString.padStart(2, '0');
      } else if (day > 31) {
        dayString = '30';
      }

      return `${year}-${monthString}-${dayString}T12:00:00`;
    }

    return expiteValue;
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public GetInsurance() {
    try {
      this.loading = true;

      let url = `Insurance?pageNumber=1&pageSize=1000&paging=false&orderBy=username&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.insuranceList = result
              .data!.filter((current) => current.nickName !== 'نسخه آزاد')
              .map((current) => ({
                id: current.id,
                name: current.nickName,
                persianName: current.nickName,
              }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public clearBackEndRequest() {
    this.backendJson = new InsuranceReportRequest();
    this.totalReport = undefined;
  }

  public validationBackend(): boolean {
    if (this.backendJson.insuranceId == null) {
      this.logger.addError('Choose_Insurance_Error', false);
      return false;
    }
    if (this.backendJson.startDate == '') {
      this.backendJson.startDate = undefined;
    }
    if (this.backendJson.endDate == '') {
      this.backendJson.endDate = undefined;
    }
    return true;
  }

  public GetReport() {
    try {
      if (!this.validationBackend()) {
        return;
      }

      this.loading = true;

      this.backendJson.insuranceReportType = 2;
      let url = `Insurance/InsuranceSaleReport`;
      this.apiService
        .postItem(new ApiRequestModel(url, this.backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.totalReport = result.data;
              setTimeout(() => {
                var element = document.getElementById('total-report-box');
                element?.classList.remove('animate__backInDown');
              }, 1000);
            } else {
              this.logger.addBackEndMessage(result);
            }

            this.loading = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public GetPrint() {
    try {
      if (!this.validationBackend()) {
        return;
      }

      this.loading = true;
      const userInformation = this.dataService.getData('UserInformation');
      this.backendJson.insuranceReportType = 1;
      const insurance = this.insuranceList.find(
        (current) => current.id == this.backendJson.insuranceId
      );
      this.backendJson.insuranceName =
        this.backendJson.insuranceName ?? insurance.persianName ?? '';
      let url = `Insurance/InsuranceSaleReport`;
      this.apiService
        .postItem(new ApiRequestModel(url, this.backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.printService.printReport(
                result.data,
                userInformation.drugStoreName,
                this.backendJson.insuranceName,
                this.backendJson.startDate ?? '',
                this.backendJson.endDate ?? ''
              );
            } else {
              this.logger.addBackEndMessage(result);
            }

            this.loading = false;
          },

          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }
}
